import { getEstacionamento, getRevenda, getUsuarioCompact } from '../../config/auth';
import { sendLogByUser } from '../../shared/analytics';
import { WhereField } from '../../shared/constants';
import { generateUUIDV7, isNullOrEmpty } from '../../shared/utils';
import { docsToItem, docsToItems, docToItem } from '../transform.docs';
// import { where } from "firebase/firestore"
import { db } from '../../config/firebase';

import {
    collection as collectionFirebase,
    deleteDoc as deleteDocFirebase,
    doc,
    getCountFromServer,
    getDoc as getDocFirebase,
    getDocs,
    limit as limitFirebase,
    query,
    setDoc,
    updateDoc as updateDocFirebase,
    where
} from "firebase/firestore";

export const getAllDocsByParkId = async ({ collection, estacionamentoId }) => {
    if (isNullOrEmpty(collection)) {
        alert("getCountByQueries: Collection is null or empty")
        return []
    }
    if (isNullOrEmpty(estacionamentoId)) {
        alert(`getAllDocsByCollection: ${estacionamentoId} is null or empty`)
        return []
    }
    const docs = await getDocs(query(
        collectionFirebase(db, collection),
        where(WhereField.PARKID, "==", estacionamentoId),
    ))
    return docsToItems(docs)
}

export const getDocByParkId = async ({ collection, estacionamentoId }) => {
    const items = await getAllDocsByParkId({ collection: collection, estacionamentoId: estacionamentoId })
    if (items.length === 0) {
        return null
    }
    return items[0]
}

export const getAllDocsByClientId = async ({ collection, clienteId }) => {
    if (isNullOrEmpty(collection)) {
        alert("getAllDocsByClientId: Collection is null or empty")
        return []
    }
    const docs = await getDocs(query(
        collectionFirebase(db, collection),
        where(WhereField.CLIENTEID, "==", clienteId),
    ))
    return docsToItems(docs)
}

export const getAllDocs = async ({ collection }) => {
    if (isNullOrEmpty(collection)) {
        alert("getCountByQueries: Collection is null or empty")
        return []
    }
    const docs = await getDocs(query(
        collectionFirebase(db, collection)
    ))
    return docsToItems(docs)
}

export const getAllDocsByQueries = async ({ collection, queries }) => {
    try {
        if (isNullOrEmpty(collection)) {
            alert("getCountByQueries: Collection is null or empty")
            return []
        }
        var qs = queries?.filter(e => e !== false)
        if (isNullOrEmpty(qs)) {
            return []
        }
        const q = query(collectionFirebase(db, collection), ...qs)
        const docs = await getDocs(q)
        return docsToItems(docs)
    } catch (error) {
        console.log(error)
        return []
    }
}

export const getDocByQueries = async ({ collection, queries }) => {
    try {
        if (isNullOrEmpty(collection)) {
            alert("getCountByQueries: Collection is null or empty")
            return null
        }
        var qs = queries?.filter(e => e !== false)
        if (isNullOrEmpty(qs)) {
            return null
        }
        const q = query(collectionFirebase(db, collection), ...qs, limitFirebase(1))
        const docs = await getDocs(q)
        return docsToItem(docs)
    } catch (error) {
        console.log(error)
        return null
    }
}

export const getCountByQueries = async ({ collection, queries }) => {
    try {
        if (isNullOrEmpty(collection)) {
            alert("getCountByQueries: Collection is null or empty")
            return 0
        }
        var qs = queries?.filter(e => e !== false)
        const q = query(collectionFirebase(db, collection), ...qs)
        const snapshot = await getCountFromServer(q)
        return snapshot.data().count
    } catch (error) {
        console.log("Index: ", error)
        return 0
    }
}

export const getAllDocsByRevendaId = async ({ collection, revendaId }) => {
    if (isNullOrEmpty(collection)) {
        alert("getAllDocsByCollection: Collection is null or empty")
        return []
    }
    if (isNullOrEmpty(revendaId)) {
        alert(`getAllDocsByCollection: ${revendaId} is null or empty`)
        return []
    }
    const docs = await getDocs(query(
        collectionFirebase(db, collection),
        where(WhereField.REVENDAID, "==", revendaId),
    ))
    return docsToItems(docs)
}

export const getAllDocsByCollection = async ({ collection }) => {
    if (isNullOrEmpty(collection)) {
        alert("getAllDocsByCollection: Collection is null or empty")
        return []
    }
    const docs = await getDocs(query(
        collectionFirebase(db, collection),
    ))
    return docsToItems(docs)
}

export const getDocById = async ({ collection, id }) => {
    if (!isNullOrEmpty(id)) {
        const item = await getDocFirebase(doc(db, collection, id))
        return docToItem(item)
    } else {
        alert(`Id nulo ou vazio: ${collection}`)
    }
    return null
}

export const addDoc = async ({ collection, data }) => {
    if (!data.id) {
        const id = generateUUIDV7();
        data.id = id
    }
    const estacionamento = getEstacionamento()
    if (!data.clienteId) {
        data.clienteId = estacionamento?.clienteId
    }
    if (!data.estacionamentoId) {
        data.estacionamentoId = estacionamento?.id
    }
    if (!data.revendaId) {
        data.revendaId = estacionamento?.revendaId
    }
    if (!data.createdBy) {
        data.createdBy = getUsuarioCompact()
    }
    data.deviceIdentifier = generateUUIDV7()
    data.createdAt = new Date()
    data.isDeleted = false
    if (isNullOrEmpty(data.origin)) {
        data.origin = "admin"
    }
    try {
        await setDoc(doc(db, collection, data.id), data, { merge: true })       
        return data
    } catch (error) {
        console.log(error);
        return null
    }
}

export const updateDoc = async ({ collection, id, data }) => {
    data.id = id
    data.updatedBy = getUsuarioCompact()
    data.updatedAt = new Date()
    data.deviceIdentifier = generateUUIDV7()
    if (!data.revendaId) {
        data.revendaId = getRevenda()?.id
    }
    if (data) {
        await updateDocFirebase(doc(db, collection, id), data, { merge: true })
    }
}

export const deleteDoc = async ({ collection, id }) => {
    const user = getUsuarioCompact()
    const data = await getDocById({ collection: collection, id: id })
    if (data) {
        try {
            data.isDeleted = true
            data.deletedBy = user
            data.deviceIdentifier = generateUUIDV7()
            data.deletedAt = new Date()
            sendLogByUser(collection, `Removeu o registro ${collection}/${id}`, data)
            await deleteDocFirebase(doc(db, collection, id))
            // updateDoc({ collection: collection, id: id, data: data })   
        } catch (error) {
            console.log(error);
        }
    }
}

export const restoreDoc = async ({ collection, id }) => {
    const user = getUsuarioCompact()
    const data = await getDocById({ collection: collection, id: id })
    data.isDeleted = false
    data.restoredBy = user
    data.restoredAt = new Date()
    sendLogByUser("Backup", `Restaurou o registro ${collection}/${id}`, data)
    await updateDoc({ collection: collection, id: id, data: data })
}